// 3.衡量商品详情获得的浏览
function snapProductDetailBrowse(prams: Record<string, any> = {}) {
    window.snaptr &&
        window.snaptr("track", "VIEW_CONTENT", {
            item_category: prams.items.category,
            item_ids: [prams.items.id],
        });
}
// 4.衡量将商品添加到购物车
function snapProductAddToCar(prams: Record<string, any> = {}) {
    if (Array.isArray(prams.items)) {
        prams.items.forEach((item) => {
            window.snaptr &&
                window.snaptr("track", "ADD_CART", {
                    currency: "GBP",
                    price: item.price,
                    item_ids: [item.id],
                });
        });
    } else {
        window.snaptr &&
            window.snaptr("track", "ADD_CART", {
                currency: "GBP",
                price: prams.items.price,
                item_ids: [prams.items.id],
            });
    }
}
//检测GA是否加载完成
function snapLoadedPromise() {
    let timer: any = null;
    return new Promise((rev, rej) => {
        if (window && window.snaptr) {
            rev(true);
        } else {
            timer = setInterval(() => {
                if (window && window.snaptr) {
                    rev(true);
                    clearInterval(timer);
                }
            }, 50);
        }
    });
}

export {
    snapProductDetailBrowse, //商品详情获得的浏览
    snapProductAddToCar, //添加到购物车
    snapLoadedPromise,
};
